import type { IReportOption } from "@src/types/AppTypes";
import { Dispatch, createContext } from "react";

export const ReportContext = createContext<IReportOption[]>([]);
export const ReportDispatchContext = createContext<
  Dispatch<{ type: "setReportOptions"; payload: IReportOption[] }>
>(() => {});

export const reportOptionsReducer = (
  state: IReportOption[],
  action: { type: "setReportOptions"; payload: IReportOption[] }
) => {
  if (action.type === "setReportOptions") {
    return action.payload;
  } else {
    return state;
  }
};
